var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 17,
  viewBox: "0 0 18 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#528AEA",
  fillRule: "evenodd",
  d: "M17.185 1.72L15.536.073 9 6.608 2.464.072.814 1.72l6.537 6.536-6.536 6.537 1.649 1.648L9 9.906l6.536 6.536 1.65-1.648-6.537-6.537z"
})));
export default __webpack_public_path__ + "teg/media/closeFilled.06e3a833.svg";
export { SvgComponent as ReactComponent };